/* Group (teacher's class) picker. Picking a group with exactly one session
   derives the session silently; several sessions surface the session step. */
import { GROUPS } from '../data';
import { useSurvey } from '../SurveyContext';

export function GroupStep() {
  const surveyFlow = useSurvey();
  return (
    <div className="intake-opts">
      {GROUPS.map((g, i) => (
        <button type="button"
          key={g.id}
          className="intake-opt"
          aria-pressed={surveyFlow.answers.teacherId === g.id}
          onClick={() => surveyFlow.selectGroup(g.id)}
        >
          <span className="intake-k">{i + 1}</span>
          <span>{g.label}</span>
        </button>
      ))}
    </div>
  );
}
